import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  root: {
    position: 'absolute',
    // Fix Firefox render where the unit text was one pixel down
    lineHeight: 'unset',
  },
  value: {
    display: 'inline-block',
    visibility: 'hidden',
  },
  unit: {
    display: 'inline-block',
    marginLeft: theme.spacing(0.5),
  },
  units: {
    position: 'relative',
    zIndex: 1,
    display: 'inline-block',
  },
});
